import React, {useState} from 'react';
import { Toast } from 'react-bootstrap';
// import MessagesContainer from "./MessagesContainer";

function Message({ variant, children }) {
  const [show, setShow] = useState(true);
  const toggleShow = () => setShow(!show);

  return (
      // <MessagesContainer>
        <Toast
          onClose={toggleShow}
          show={show}
          delay={5000}
          autohide
          bg={variant}
        >
          <Toast.Header>
            <strong className="me-auto">Рієстро</strong>
            <small className="text-muted">Щойно</small>
          </Toast.Header>
          <Toast.Body>{children}</Toast.Body>
        </Toast>
      // </MessagesContainer>
  );
}

export default Message;
